import React, { useState } from 'react';
import { Modal, SparkModalPortal, Spinner } from '@spark';
import CostEstimateFooter from '@/features/billing/components/CostEstimateFooter';
import { TrainFromSpecificUsecase } from '@/features/trainings/components/TrainFromSpecificUsecase';
import ReviewDataOverview from './ReviewDataOverview';
import {
    FULL_TRAINING_OVERVIEW_TITLE,
    REVIEW_PLAN_TITLE,
    START_TRAINING_LABEL,
} from './reviewOverview';

/**
 * Review Training Plan: data overview plus the existing summary-modal train
 * surface. Cancel stays on Model Setup. Start Training runs the same train
 * action the Train step used. A low label count warns; it does not disable
 * Start Training. Existing train blockers still do.
 *
 * Two exits finish the wizard through `onFinished`: a training that actually
 * started, and a scheduled auto-train once its "Training will start when
 * data is ready" modal is dismissed (`onFinished({ trainingScheduled: true })`).
 */
const ReviewTrainingPlanModal = ({
    open,
    hidden = false,
    usecase,
    refreshKey = 0,
    moveToScreen,
    onClose,
    onFinished,
    onOpenDataEditor,
}) => {
    const [trainAction, setTrainAction] = useState(null);

    const handleTrainingStarted = () => {
        onFinished?.();
    };
    const handleAutoTrainScheduled = () => {
        onFinished?.({ trainingScheduled: true });
    };

    return (
        <SparkModalPortal
            open={open}
            hidden={hidden}
            onClose={onClose}
            size="wide"
            destroyOnClose
            className="cw-review-plan-portal"
        >
            <Modal
                title={REVIEW_PLAN_TITLE}
                showSubtitle={false}
                className="cw-review-plan-modal"
                primaryLabel={trainAction?.loading ? 'Training…' : START_TRAINING_LABEL}
                primaryIcon={trainAction?.loading ? <Spinner size="small" /> : undefined}
                primaryDisabled={!trainAction || !!trainAction.disabled || !!trainAction.loading}
                primaryDisableWhenReadOnly
                tertiaryLabel="Cancel"
                showFooterSlot={Boolean(trainAction?.usecaseId)}
                footerSlot={
                    trainAction?.usecaseId ? (
                        <CostEstimateFooter
                            operation="train"
                            label="model training"
                            params={{ usecase_id: trainAction.usecaseId }}
                            refreshKey={refreshKey}
                        />
                    ) : null
                }
                onPrimaryClick={() => {
                    void trainAction?.onClick?.();
                }}
                onTertiaryClick={onClose}
                onCloseClick={onClose}
            >
                {open ? (
                    <div className="cw-review-plan">
                        {/* Running data flows show inside Data Overview (the
                            "Processing your data…" state); the auto-train
                            banner the task page's Train tab shows is not
                            rendered here. */}
                        <ReviewDataOverview
                            usecase={usecase}
                            refreshKey={refreshKey}
                            onReviewExamples={() => onOpenDataEditor?.()}
                        />
                        <TrainFromSpecificUsecase
                            layout="summary-modal"
                            embeddedInTaskDrawer
                            summaryTitle={FULL_TRAINING_OVERVIEW_TITLE}
                            hideAutoTrainSection
                            moveToScreen={moveToScreen}
                            onTrainActionChange={setTrainAction}
                            onTrainingStarted={handleTrainingStarted}
                            onAutoTrainScheduled={handleAutoTrainScheduled}
                            onNavigateAway={onClose}
                            onOpenDataEditor={onOpenDataEditor}
                        />
                    </div>
                ) : null}
            </Modal>
        </SparkModalPortal>
    );
};

export default ReviewTrainingPlanModal;
